import classNames from 'clsx';
import React from 'react';

import styles from './CasinoHeaderTitle.scss';

export interface Props {
  title?: string;
  subTitle?: string;
  className?: string;
  variant?: 'card';
}

const CasinoHeaderTitle: React.FC<Props> = ({ className, title, subTitle, variant }) => {
  if (!title) {
    return null;
  }

  return (
    <div
      className={classNames(styles.content, className, {
        [styles.cardTitle]: variant
      })}
    >
      <h2
        className={classNames(styles.title, {
          [styles.cardTitle]: variant,
          [styles.hasSubtitle]: subTitle
        })}
      >
        {title}
      </h2>
      {subTitle ? (
        <p className={classNames(styles.subtitle, { [styles.cardTitle]: variant })}>{subTitle}</p>
      ) : null}
    </div>
  );
};

export default CasinoHeaderTitle;
